import React, { useState, useEffect, useRef  } from "react";
import { Button } from "../components/ui/button";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale } from "chart.js";
import { FaUserCircle } from "react-icons/fa";
import { Card, CardContent } from "../components/ui/card";
import BalanceCard from "./BalanceCard";
import Menu from './menu';
import axios from '../axiosInstance';
import jwtDecode from "jwt-decode"; // Pour décoder le token JWT
import rollercoinBanner from "../assets/images/bannerRollerCoin.gif"; // Image de bannière RollerCoin
import logoBanner from "../assets/images/new_logo_without_font.png";
import ReCAPTCHA from "react-google-recaptcha";
import { FaTelegramPlane, FaFacebookF, FaXTwitter } from "react-icons/fa6";
import HighPerformanceAd from "../components/HighPerformanceAd";

// Initialisation des composants ChartJS pour afficher des graphiques
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale);

function Toast({ message, type = "error", onClose }) {
  return (
    <div className={`fixed top-6 left-1/2 transform -translate-x-1/2 z-50 px-4 py-3 rounded shadow-lg text-white ${type === "error" ? "bg-red-600" : "bg-green-600"}`}>
      <div className="flex items-center space-x-2">
        <span>{message}</span>
        <button onClick={onClose} className="ml-2 text-white hover:text-gray-300 font-bold">×</button>
      </div>
    </div>
  );
}



// Composant principal de la page Marketplace
export default function AutosurfValidation({ onLogout }) {
  const [options, setOptions] = useState(0); // Options disponibles dans le marketplace
  const [coinz, setCoinz] = useState(0); // Solde en COINZ
  const [selfWeeklyProfit, setSelfWeeklyProfit] = useState(0) // Son propre bénéfice
  const [balance, setBalance] = useState(300); // Solde de l'utilisateur
  const [weeklyProfit, setWeeklyProfit] = useState(0); // Bénéfice hebdomadaire
  const [toast, setToast] = useState({ message: "", type: "" });
  const [message, setMessage] = useState("");
  const recaptchaRef = useRef();
  const [captchaToken, setCaptchaToken] = useState(null);
  const [level, setLevel] = useState(0);
  const [xp, setXp] = useState(0);
  const navigate = useNavigate();
  const showToast = (message, type = "error") => {
	console.log("test");
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };
	
 // 📡 RÉCUPÉRATION DES DONNÉES UTILISATEUR via l'API
  const getUserData = () => {   

    axios.get(`/api/user/me`,{ withCredentials: true })
      .then((response) => {
        const { coinz, options,systemCoinz, weeklyProfit, lastclaim, userLevel, user_Xp } = response.data;
        const valeurCalculee = options > 0 ? (( systemCoinz / weeklyProfit) * options) : 0;  // On évite la division par 0
		
		setSelfWeeklyProfit(valeurCalculee);
        setCoinz(coinz);
        setOptions(options);
        setWeeklyProfit(weeklyProfit);  
		setLevel(userLevel);
		setXp(user_Xp);
        // setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
      
      });
  };

   const handleValidation = async () => {
    
	if (!captchaToken) {
      showToast("Please validate the captcha.", "error");
      return;
    }  
  
    try {
      const res = await axios.post("/api/autosurf/validate", {
      captchaToken: captchaToken, // on l'envoie au backend
	  level:level,
	  xp:xp,
    }, { withCredentials: true });
	console.log(res.data);
      if (res.data.success) {
        showToast("Session validated! Your COINZ have been credited.","success");
        setTimeout(() => navigate("/dashboard"), 3000);
      } else {
		console.error(res.data.message);
        showToast("Session invalid. You must remain active for 60 minutes.","error");
      }
    } catch (err) {
      console.error("Erreur de validation : " + (err.response?.data?.message || "Erreur inconnue."));
	  showToast("Validation error :" + err.response?.data?.message,"error");
    } 
  };
  // Appeler la fonction au chargement du composant
  useEffect(() => {
	getUserData();
  }, []);
  return (
    <>
    {toast.message && (
      <Toast
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ message: "", type: "" })}
      />
    )}
<div className="min-h-screen bg-gray-950 text-white flex flex-col lg:flex-row">
  {/* 🄿🆄🄱 ➤ LEFT AD */}
  <div className="hidden lg:block w-48 p-4">
    <div className="bg-gray-800/70 rounded-lg h-full flex items-center justify-center text-xs text-gray-400">
      {/* Contenu pub gauche */}
    </div>
  </div>

    {/* ➤ MAIN CONTENT */}
    <div className="flex-1 w-full px-4 py-6">
    {/* 🔝 HEADER */}
    <header className="mb-8 border-b border-gray-800 pb-4">
      <div className="flex flex-wrap items-center justify-between gap-4">
       
        <div className="text-sm font-medium">
          <CardContent>
            <Menu onLogout={onLogout} />
          </CardContent>
        </div>
      </div>
    </header>

    {/* 🄸🄵🅁🄰🄼🄴 🔽 always visible and responsive */}
    <Card className="bg-gray-900 border border-gray-700 mb-6">
      <CardContent className="py-4">
        <div className="w-full flex justify-center mb-6 overflow-x-auto">
          <iframe
            data-aa="2393851"
            src="//ad.a-ads.com/2393851?size=970x90&background_color=102445"
            style={{ width: "970px", height: "90px", border: "0", padding: "0", backgroundColor: "transparent" }}
            title="Publicité CoinzUp"
            className="w-full max-w-full"
          ></iframe>
        </div>
      </CardContent>
    </Card>

    {/* 🄸🄽🄵🄾 SOLDE / OPTIONS */}
    <div className="grid md:grid-cols-1 gap-4 mb-6">
      <BalanceCard balance={coinz} optionsOwned={options} estimatedWeeklyGain={selfWeeklyProfit} />
    </div>

    {/* Section Validation AutoSurf */}
    <div className="flex justify-center items-center">
      <div className="bg-gray-800/80 rounded-lg shadow-xl p-6 w-full max-w-lg">
        <h1 className="text-3xl font-bold mb-4 text-center text-white">Validation de session AutoSurf</h1>
        <p className="mb-6 text-gray-400 text-center max-w-xl mx-auto">
          You have reached the end of your AutoSurf session. To be credited, please validate.
        </p>

        {/* CAPTCHA */}
        <ReCAPTCHA
          sitekey="6LeRXTErAAAAABw214tL2nCwxDvCJ-EKAfoAkUSg"
          ref={recaptchaRef}
          onChange={(token) => setCaptchaToken(token)}
        />
        
        {/* Bouton de validation */}
        <div className="mt-6 text-center">
          <Button
            onClick={handleValidation}
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            Validate
          </Button>
        </div>
      </div>
    </div>

  </div>

    {/* 🄿🆄🄱 ➤ RIGHT AD */}
  <div className="hidden lg:block w-48 p-4">
    <div className="bg-gray-800/70 rounded-lg h-full flex items-center justify-center text-xs text-gray-400">
      {/* Contenu pub droite */}
    </div>
  </div>
</div>
	{/* Footer en dehors du bloc principal */}
  <footer className="bg-gray-950 text-center text-sm text-gray-500 py-4 border-t border-gray-800">

<div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6">
  <div>
    © 2025 CoinzUp.net. All rights reserved. &nbsp;
    <Link to="/notice" className="hover:text-white underline">Privacy & Legal Notice</Link> &nbsp;
    <Link to="/terms" className="hover:text-white underline">Terms & Conditions</Link>
  </div>

  <div className="flex gap-4 mt-2 md:mt-0">

    <a href="https://www.facebook.com/profile.php?id=61576040825765" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-lg">
      <FaFacebookF />
    </a>
    <a href="https://x.com/coinzup2025" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-lg">
      <FaXTwitter />
    </a>
  </div>
</div>
</footer>
    </>
  );
}
